import React, { useState, useEffect } from 'react';
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

import Button from "../../atoms/button/button";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import { normalizeTwoWords, formatImageAlt } from "../../../shared/utils/stringUtilities";
import RecommenderModal from '../../organisms/recommender-modal/recommenderModal';

import './prominent.scss';
import { GatsbyImage } from "gatsby-plugin-image";

const Prominent = (props: ReferenciaContenido) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [NoContent, setNoContent] = useState(false)

  const rpc = props.referenciaPlantillaContenido[0];
  const toggleModalVisible = () => setIsModalVisible(!isModalVisible);

  useEffect(() => {
    if (rpc.tituloBoton === 'sinBoton') {
      setNoContent(true);
    }
  }, [])

  return (
    <div className="m-prominent">
      <div className="m-prominent__background">
        {rpc.imagenPrincipal && (
          rpc.imagenPrincipal[0].gatsbyImageData ?
          <a href={rpc.redireccionBoton || 'www.google.com'}>
            <GatsbyImage
              className={`m-prominent__cover ${NoContent ? 'nobutton' : ''}`}
              image={rpc.imagenPrincipal[0].gatsbyImageData}
              alt={rpc.imagenPrincipal[0].title ? 
                formatImageAlt(rpc.imagenPrincipal[0].title) :
                `Imagen ${rpc.tituloBanner}`
              }
            />
          </a>
            :
            <a href={rpc.redireccionBoton || 'www.google.com'} >
              <img
                className={`m-prominent__cover ${NoContent ? 'nobutton' : ''}`}
                src={rpc.imagenPrincipal[0].file.url}
                alt={rpc.imagenPrincipal[0].title ? 
                  formatImageAlt(rpc.imagenPrincipal[0].title) :
                  `Imagen ${rpc.tituloBanner}`
                }
              />
            </a>
        )}
      </div>

      <article className={`m-prominent__content ${NoContent ? 'nobutton' : ''}`}>
        <h3 className="m-prominent__title m-prominent__title__text">
          {rpc.tituloBanner}
        </h3>
        {rpc.descripcion && (
          <div className="m-prominent__description">
            {documentToReactComponents(rpc.descripcion.json)}
          </div>
        )}
        <div className="m-prominent__button">
          <Button
            id="buttonProminent"
            type={rpc.redireccionBoton ? "link" : "button"}
            href={rpc.redireccionBoton}
            classname={"secondary "}
            icon={rpc.tipoTitulo}
            text={rpc.tituloBoton}
            isDisabled={false}
            gtmMark={`gtm${normalizeTwoWords(
              props.nombreCategoria
            )}${normalizeTwoWords(rpc.tituloBanner)}Btn`}
            onClickAction={!rpc.redireccionBoton ? toggleModalVisible : undefined}
          />
        </div>
      </article>
      <RecommenderModal 
        open={isModalVisible} 
        onClose={toggleModalVisible}
      />
    </div>
  )
}

export default Prominent;